<template>
    <div id="app" >
      <top-nav/>
      <router-view />
      <foot-button/>
    </div>
  </template>

<script>
import { TopNav, FootButton } from '@/components'
export default {
  name: 'BaseLayout',
  components: {
    TopNav,
    FootButton
  },
  data () {
    return {}
  },
  computed: {},
  created () {},
}
</script>

  <style lang="scss">
    @import "@/assets/styles/index.scss";
    @import "@/assets/mobile/index.scss";
  </style>
